const MEDIA_ITEMS = [
  {
    id: 'm1',
    title: '深度解析：七月娱乐圈最热门事件全梳理',
    desc: '从绯闻曝光到官宣回应，完整复盘本月娱乐圈五大热门事件。',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20illustration%20of%20video%20player%20interface%20with%20warm%20coral%20gradient%20play%20button%2C%20modern%20editorial%20content%20creator%20style%2C%20clean%20minimalist%20design%2C%20abstract%20entertainment%20visualization%2C%20no%20text%2C%20professional%20aesthetic&width=640&height=360&seq=media-item-01&orientation=landscape',
    duration: '15:28',
    views: '12.3万',
  },
  {
    id: 'm2',
    title: '网红翻车名场面合集：那些让人印象深刻的瞬间',
    desc: '盘点半年来最经典的网红翻车现场，每一个都是网络热门事件的代表作。',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20illustration%20of%20video%20player%20with%20dramatic%20warm%20amber%20lighting%2C%20compilation%20screen%20aesthetic%2C%20modern%20minimalist%20design%2C%20editorial%20content%20style%2C%20no%20text%2C%20clean%20composition&width=640&height=360&seq=media-item-02&orientation=landscape',
    duration: '22:15',
    views: '18.7万',
  },
  {
    id: 'm3',
    title: '热搜事件速览：本周十大网络热门事件回顾',
    desc: '五分钟带你快速了解本周所有你不能错过的网络大事件。',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20illustration%20of%20news%20video%20thumbnail%20with%20warm%20golden%20and%20coral%20accents%2C%20modern%20minimalist%20editorial%20design%2C%20trending%20topics%20visual%20metaphor%2C%20clean%20composition%2C%20no%20text&width=640&height=360&seq=media-item-03&orientation=landscape',
    duration: '05:42',
    views: '25.1万',
  },
  {
    id: 'm4',
    title: '吃瓜前线：最新热门爆料一手解读',
    desc: '第一时间为你解读最新流出的热门爆料信息，分析事件走向与各方反应。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20modern%20illustration%20of%20breaking%20news%20video%20screen%20with%20warm%20red%20alert%20style%2C%20editorial%20broadcast%20aesthetic%2C%20clean%20minimalist%20design%2C%20coral%20gradients%2C%20no%20text&width=640&height=360&seq=media-item-04&orientation=landscape',
    duration: '18:09',
    views: '9.4万',
  },
  {
    id: 'm5',
    title: '年度吃瓜大盘点：那些震撼全网的大事件',
    desc: '精选今年以来最具话题度的网络热门事件，回顾每个让你惊掉下巴的瞬间。',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20illustration%20of%20year%20in%20review%20video%20montage%20with%20warm%20amber%20and%20coral%20lighting%2C%20modern%20minimalist%20editorial%20design%2C%20clean%20composition%2C%20abstract%20data%20visuals%2C%20no%20text&width=640&height=360&seq=media-item-05&orientation=landscape',
    duration: '35:50',
    views: '32.6万',
  },
];

export default function Media() {
  return (
    <section id="media" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">
          视频速览
        </h2>
        <p className="text-sm text-foreground-600 text-center mb-10">
          热门事件视频解读，快速了解来龙去脉
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {MEDIA_ITEMS.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 rounded-xl overflow-hidden border border-background-200/60 cursor-pointer group"
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-black/40 backdrop-blur-sm flex items-center justify-center group-hover:bg-primary-500/80 transition-colors">
                    <i className="ri-play-fill text-white text-xl ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-2 right-2 text-xs text-white bg-black/50 rounded px-1.5 py-0.5 whitespace-nowrap">
                  {item.duration}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 mb-1.5 group-hover:text-primary-500 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-600 line-clamp-1 mb-2">{item.desc}</p>
                <span className="text-xs text-foreground-500">
                  <i className="ri-eye-line mr-1"></i>{item.views} 次播放
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}